module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-flat-screen-9345dd99b363880a5c06f898810e6ab9.png";